<template>
  <b-modal id="edit_contact_modal" ref="edit_contact_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="fas fa-user-edit"></i>
          <span>Edit Contact</span>
        </h1>
        <p id="mh-info">You are editing : {{ current_contact_full_name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <div>
      <ValidationObserver ref="editContactForm" slim>
        <form role="form" @submit.prevent="update_contact()">
          <div class="row">
            <div class="col-12 form-group">
              <validationProvider rules="required" v-slot="{errors, classes}" name="Job Title" tag="div">
                <label class="form-label" for="job_title">Job Title</label>
                <multiselect v-model="contact.job_title" placeholder="" label="job_title" id="job_title" track-by="id" :options="ms_opts.job_titles" :option-height="200"
                             :custom-label="job_title_label" :show-labels="false" class="requiredField" :class="classes">
                  <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc_single">
                      <span class="option__title">{{ props.option.job_title }}</span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.job_title }}</span>
                      <span class="option__small">{{ props.option.sector_name }}</span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </validationProvider>
            </div>

            <div class="col-12 form-group">
              <validationProvider rules="required" v-slot="{errors, classes}" name="Title" tag="div">
                <label class="form-label" for="title">Title</label>
                <multiselect v-model="contact.title" id="title" name="title" placeholder="" class="requiredField" track-by="id" :class="classes" label="value"
                             :options="ms_opts.titles"></multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </validationProvider>
            </div>

            <div class="col-6 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="First Name" tag="div">
                <label class="form-label" for="first_name">First Name</label>
                <input v-model="contact.first_name" name="first_name" type="text" class="form-input requiredField" :class="classes" id="first_name"
                       @input="forceCapitalize($event, contact, 'first_name')">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-6 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Surname" tag="div">
                <label class="form-label" for="surname">Surname</label>
                <input v-model="contact.surname" name="surname" type="text" class="form-input requiredField" :class="classes" id="surname"
                       @input="forceCapitalize($event, contact, 'surname')">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-6 form-group">
              <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Personal Landline" tag="div">
                <label class="form-label" for="personal_landline">Personal Landline</label>
                <input type="text" v-model="contact.personal_landline" id="personal_landline" name="personal_landline" class="form-input" :class="classes" maxlength="15">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-6 form-group">
              <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Personal Mobile" tag="div">
                <label class="form-label" for="personal_mobile">Personal Mobile</label>
                <input type="text" v-model="contact.personal_mobile" id="personal_mobile" name="personal_mobile" class="form-input" :class="classes" maxlength="15">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-6 form-group">
              <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Work Landline" tag="div">
                <label class="form-label" for="work_landline">Work Landline</label>
                <input type="text" v-model="contact.work_landline" id="work_landline" name="work_landline" class="form-input" :class="classes" maxlength="15">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-6 form-group">
              <ValidationProvider rules="decimal|max:15" v-slot="{errors, classes}" name="Work Mobile" tag="div">
                <label class="form-label" for="work_mobile">Work Mobile</label>
                <input type="text" v-model="contact.work_mobile" id="work_mobile" name="work_mobile" class="form-input" :class="classes" maxlength="15">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12 form-group">
              <ValidationProvider rules="email" v-slot="{errors, classes}" name="Personal Email Address" tag="div">
                <label class="form-label" for="personal_email">Personal Email Address</label>
                <input type="email" v-model="contact.personal_email" id="personal_email" class="form-input" :class="classes">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-12 form-group">
              <ValidationProvider rules="email" v-slot="{errors, classes}" name="Work Email Address" tag="div">
                <label class="form-label" for="work_email">Work Email Address</label>
                <input type="email" v-model="contact.work_email" id="work_email" class="form-input" :class="classes">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12">
              <div class="float-right">
                <button type="submit" class="btn orcaBtn">SAVE and CLOSE</button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: "edit_contact",
  components: {
    Multiselect
  },
  data() {
    return {
      current_contact_full_name: '',
      ms_opts: {
        job_titles: this.$store.state.crm_options.job_titles,
        titles: this.$store.state.crm_options.person_title,
      },
      existing_contact: {},
      contact: {
        id: null,
        company_id: null,
        job_title: null,
        title: null,
        first_name: '',
        surname: '',
        phone: '',
        mobile: '',
        email: ''
      },
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact/' + this.$store.state.contacts.modal.contact_id).then(contact => {
      this.existing_contact = contact.data;
      this.contact = {
        id: contact.data.id,
        company_id: contact.data.company_id,
        job_title: contact.data.rel_profile.job_title,
        title: contact.data.person.title,
        first_name: contact.data.person.first_name,
        surname: contact.data.person.surname,

        personal_landline: contact.data.phones.personal_landline,
        personal_mobile: contact.data.phones.personal_mobile,
        personal_email: contact.data.emails.personal_email,
        work_landline: contact.data.phones.work_landline,
        work_mobile: contact.data.phones.work_mobile,
        work_email: contact.data.emails.work_email,
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }
      this.current_contact_full_name = contact.data.person.first_name + ' ' + contact.data.person.surname;
    });
  },
  methods: {
    job_title_label({sector_name, job_title}) {
      return `${job_title} - ${sector_name}`
    },
    hideModal() {
      this.$refs.edit_contact_modal.hide();
      this.$store.commit('HIDE_CONTACT_MODAL')
    },
    update_contact() {
      this.$refs.editContactForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editContactForm);
        }
        else {
          let contact_promises = [];
          // Person
          contact_promises.push(new Promise(resolve => {
            let submit_person = {
              id: this.existing_contact.person.id,
              title_id: this.contact.title.id,
              first_name: this.contact.first_name,
              surname: this.contact.surname,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            };
            axios.patch(this.crmApiPath + 'person/' + submit_person.id, submit_person).then(() => resolve());
          }));
          // Contact Profile
          contact_promises.push(new Promise(resolve => {
            let submit_contact_profile = {
              id: this.existing_contact.rel_profile.id,
              company_id: this.contact.company_id,
              contact_id: this.existing_contact.id,
              job_title_id: this.contact.job_title.id,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            };
            axios.patch(this.crmApiPath + 'contact/profile/' + submit_contact_profile.id, submit_contact_profile).then(() => resolve());
          }));

          // Contact Info - Personal Landline
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.phones.personal_landline.length === 0 && this.contact.personal_landline.length > 0) {
              axios.post(this.crmApiPath + 'contact_info/phone', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                phone_type_id: 54, // personal landline
                phone_number: this.contact.personal_landline
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let phone = this.existing_contact.rel_phones.find(p => p.phone_type_id === 54);
              if (this.existing_contact.phones.personal_landline.length > 0 &&
                  (this.contact.personal_landline.length === 0 || this.contact.personal_landline.length === 0) && phone !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (phone !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  phone_number: this.contact.personal_landline
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          // Contact Info - Personal Mobile
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.phones.personal_mobile.length === 0 && this.contact.personal_mobile.length > 0) {
               axios.post(this.crmApiPath + 'contact_info/phone', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                phone_type_id: 55, // personal mobile
                phone_number: this.contact.personal_mobile
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let phone = this.existing_contact.rel_phones.find(p => p.phone_type_id === 55);
              if (this.existing_contact.phones.personal_mobile.length > 0 &&
                  (this.contact.personal_mobile.length === 0 || this.contact.personal_mobile.length === 0) && phone !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (phone !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  phone_number: this.contact.personal_mobile
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          // Contact Info - Work Landline
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.phones.work_landline.length === 0 && this.contact.work_landline.length > 0) {
              axios.post(this.crmApiPath + 'contact_info/phone', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                phone_type_id: 56, // work landline
                phone_number: this.contact.work_landline
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let phone = this.existing_contact.rel_phones.find(p => p.phone_type_id === 56);
              if (this.existing_contact.phones.work_landline.length > 0 &&
                  (this.contact.work_landline.length === 0 || this.contact.work_landline.length === 0) && phone !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (phone !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  phone_number: this.contact.work_landline
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          // Contact Info - Work Mobile
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.phones.work_mobile.length === 0 && this.contact.work_mobile.length > 0) {
              axios.post(this.crmApiPath + 'contact_info/phone', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                phone_type_id: 57, // work mobile
                phone_number: this.contact.work_mobile
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let phone = this.existing_contact.rel_phones.find(p => p.phone_type_id === 57);
              if (this.existing_contact.phones.work_mobile.length > 0 &&
                  (this.contact.work_mobile.length === 0 || this.contact.work_mobile.length === 0) && phone !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (phone !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/phone/' + phone.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Phone',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  phone_number: this.contact.work_mobile
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          // Contact Info - Personal Email
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.emails.personal_email.length === 0 && this.contact.personal_email.length > 0) {
              axios.post(this.crmApiPath + 'contact_info/email', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                email_type_id: 62, // personal email
                email_address: this.contact.personal_email
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let email = this.existing_contact.rel_emails.find(p => p.email_type_id === 62);
              if (this.existing_contact.emails.personal_email.length > 0 &&
                  (this.contact.personal_email.length === 0 || this.contact.personal_email.length === 0) && email !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/email/' + email.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (email !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/email/' + email.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  email_address: this.contact.personal_email
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          // Contact Info - Work Email
          contact_promises.push(new Promise(resolve => {
            // post
            if (this.existing_contact.emails.work_email.length === 0 && this.contact.work_email.length > 0) {
              axios.post(this.crmApiPath + 'contact_info/email', {
                company_id: this.contact.company_id,
                contact_id: this.contact.id,
                belongs_to_id: this.contact.id,
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
                record_type: 'contact',
                email_type_id: 63, // work email
                email_address: this.contact.work_email
              }).then(() => resolve());
            }
            // patch / delete
            else {
              let email = this.existing_contact.rel_emails.find(p => p.email_type_id === 63);
              if (this.existing_contact.emails.work_email.length > 0 &&
                  (this.contact.work_email.length === 0 || this.contact.work_email.length === 0) && email !== undefined) {
                // find record
                axios.delete(this.crmApiPath + 'contact_info/email/' + email.id, {
                  params: {
                    contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  }
                }).then(() => resolve());
              }
              else if (email !== undefined) {
                axios.patch(this.crmApiPath + 'contact_info/email/' + email.id, {
                  contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id,
                  record_type: 'contact',
                  email_address: this.contact.work_email
                }).then(() => resolve());
              }
              else {
                resolve();
              }
            }
          }));
          Promise.all(contact_promises).then(() => {
            this.$store.commit('SET_UPDATE_CONTACT_ID', this.contact.id);
            this.$snotify.success('Contact updated : ' + this.contact.first_name + ' ' + this.contact.surname);
            this.$bus.$emit('contacts::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            this.$bus.$emit('table::reload', {table: 'all_contacts', type: 'update'});
            this.$bus.$emit('default_company_ts_auth::reload', {action: true});
            this.$tabs.refresh('/contact/profile', true);
            this.hideModal();
          });

        }
      });
    }
  }
}
</script>

<style lang="scss">
.pac-container.pac-logo {
  z-index: 999999;
}

#edit_contact_modal {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
